import { render } from "./Warehouses.vue?vue&type=template&id=59a86c0b&scoped=true&ts=true"
import script from "./Warehouses.vue?vue&type=script&lang=ts"
export * from "./Warehouses.vue?vue&type=script&lang=ts"

import "./Warehouses.vue?vue&type=style&index=0&id=59a86c0b&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a86c0b"]])

export default __exports__